import UserModel from './user.model';
import AccountModel from './account.model';

const SHIELD_CLIENT_ID = process.env.NEXT_PUBLIC_SHIELD_CLIENT_ID;
const SHIELD_REDIRECT_URI = process.env.NEXT_PUBLIC_SHIELD_REDIRECT_URI;
const SHIELD_CLIENT_ORIGIN = process.env.NEXT_PUBLIC_SHIELD_CLIENT_ORIGIN;

const getInstance = async () => {
  if (typeof window === 'undefined') {
    return;
  }

  /**
   * We import here in order to make sure the window is available
   */
  const shieldSpaSdk = require('@workable/shield-spa-sdk');

  const shield = await shieldSpaSdk({
    origin: SHIELD_CLIENT_ORIGIN,
    clientId: SHIELD_CLIENT_ID,
    redirectUri: SHIELD_REDIRECT_URI
  });

  return shield;
};

const getShieldUser = async () => {
  const clientOptions = {
    clientId: SHIELD_CLIENT_ID,
    origin: SHIELD_CLIENT_ORIGIN
  };

  try {
    const shieldClient = await getInstance();
    const {id_token, claims} = await shieldClient.getTokenSilently(clientOptions);

    // We have to check for valid claims object here before accessing it,
    // since it will 100% throw error for signed out users.

    if (!claims || typeof claims !== 'object') {
      return null;
    }

    const {user, account} = claims;

    const accountModel = new AccountModel(account);
    const userModel = new UserModel(user, id_token, accountModel);
    const userIsValid = userModel?.account?.name?.length;

    if (!userIsValid) return null;

    return userModel;
  } catch (error) {
    console.error('Error in getAuthenticatedUser:', error);
    return null;
  }
};

const logoutSilently = async () => {
  const shieldClient = await getInstance();
  return shieldClient.logoutSilently();
};

const shieldClient = {
  getShieldUser,
  logoutSilently
};

export default shieldClient;
